import axios from "axios";
const AxiosInstance = axios.create({
  baseURL: "https://api.academyscout.app/api",
});
AxiosInstance.interceptors.request.use(
  function (config) {
    const PLAYER_SCOUT = JSON.parse(localStorage.getItem("PLAYER_SCOUT"));
    config.headers.token = PLAYER_SCOUT?.auth_details?.token;
    config.headers.apikey = PLAYER_SCOUT?.auth_details?.apikey;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

AxiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response) {
      if (error.response.status === 401) {
        console.log(error);
      } else {
        console.error("Response Error:", error.response);
      }
    } else if (error.request) {
      console.error("Request Error:", error.request);
    } else {
      console.error("Error:", error.message);
    }
    return Promise.reject(error);
  }
);

export default AxiosInstance;
